import React, { Component } from 'react';
import { Button, Modal, Dropdown } from 'semantic-ui-react'

export default class EmailRecipientModal extends Component {
  constructor(props){
    super(props);

    this.state = {
      emailRecipient: props.emailRecipient,
      options: this.generateOptions()
    }

  }

  generateOptions = () => {
    var options = []
    this.props.users.map(function(user, index){
      options = options.concat({
        key: user.id,
        text: user.email,
        value: user.email
      })
      return true
    })
    if (this.props.emailRecipient.email_recipients.length > 0){
      this.props.emailRecipient.email_recipients.map(function(email, index){
        options = options.concat({
          key: email,
          text: email,
          value: email
        })
        return true
      })
    }
    return options
  }

  onSave = (evt) => {
    this.props.saveEmailRecipient(this.state.emailRecipient)
    this.props.onClose()
  }

  handleAddition = (e, { value }) => {
    this.setState((prevState) => ({
      options: [{ text: value, value }, ...prevState.options],
    }))
  }

  handleChange = (e, { value }) => {
    var {emailRecipient} = this.state
    emailRecipient.email_recipients = (value.length === 0 ? [this.props.user.id] : value)
    this.setState({ emailRecipient })
  }

  render() {
    const { onClose } = this.props
    const { options, emailRecipient } = this.state

    return (
      <Modal size={ 'mini' } dimmer={ 'inverted' } open={ true } className='email-recipients-modal'>
        <Modal.Header>Manager Notifications Emails</Modal.Header>
        <Modal.Content>
          <label>Enter email addresses to be notified for this region</label>
          <Dropdown
            options={options}
            placeholder='Add email recipient'
            search
            selection
            fluid
            allowAdditions
            additionLabel={<Button positive content='Add' style={{padding: '8px 12px', marginRight: '10px'}}/>}
            additionPosition='bottom'
            value={emailRecipient.email_recipients}
            onAddItem={this.handleAddition}
            onChange={this.handleChange}
            multiple
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            content="Cancel"
            onClick={() => onClose()}
          />
          <Button
            positive
            content="Save"
            onClick={this.onSave}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/components/modals/email_recipient_modal.js